import { render, staticRenderFns } from "./ViewBills.vue?vue&type=template&id=22f700e8"
import script from "./ViewBills.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBills.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports